// src/domains/auth/hooks/usePasswordStrength.ts

import i18n from '@/shared/i18n/i18n';
import { Color } from '@UI/lib/utils';

export type TPasswordStrength = {
  color: Color;
  label: string;
  strength: number;
  acceptance: {
    lowercase: boolean;
    uppercase: boolean;
    number: boolean;
    special: boolean;
    length: boolean;
  };
};

export const usePasswordStrength = (password: string): TPasswordStrength => {
  let conditions = 0;
  const acceptance = {
    lowercase: false,
    uppercase: false,
    number: false,
    special: false,
    length: false,
  };
  if (password) {
    if (/[a-z]/.test(password)) {
      conditions++;
      acceptance.lowercase = true;
    }
    if (/[A-Z]/.test(password)) {
      conditions++;
      acceptance.uppercase = true;
    }
    if (/\d/.test(password)) {
      conditions++;
      acceptance.number = true;
    }
    if (/[!@#$%^&*()_+[\]{};':"|,.<>?]/.test(password)) {
      conditions++;
      acceptance.special = true;
    }
    if (password.length >= 8) {
      conditions++;
      acceptance.length = true;
    }
  }

  if (conditions <= 2) {
    return {
      color: 'red',
      label: i18n.t('generic.passwordRules.strength.weak'),
      strength: conditions,
      acceptance,
    };
  } else if (conditions < 5) {
    return {
      color: 'yellow',
      label: i18n.t('generic.passwordRules.strength.medium'),
      strength: conditions,
      acceptance,
    };
  } else {
    return {
      color: 'green',
      label: i18n.t('generic.passwordRules.strength.strong'),
      strength: conditions,
      acceptance,
    };
  }
};
